import React, { memo, useState } from 'react';

import { log } from '../../../common/common';
import ChannelHeroCard from './ChannelHeroCard';
import ClirnetIntro from './ClirnetIntro';
import ClVideoHeroCard from './ClVideoHeroCard';
import EbookHeroCard from './EbookHeroCard';
import FormArea from './FormArea';
import TrainingHeroCard from './TrainingHeroCard';
import MedwikiHeroCard from './MedwikiHeroCard';
import SessionHeroCard from './SessionHeroCard';
import SurveyHeroCard from './SurveyHeroCard';
import PollHeroCard from './PollHeroCard';
import DoctubeHeroCard from './DoctubeHeroCard';
import DiagnosisHeroCard from './DiagnosisHeroCard';
const RightLoginBar = ({
  channel_id,
  heroCardData,
  consent_text = '',
  share_type,
  page_id,
  channel_name,
  channel_logo
}) => {
  log('CHANNEL_ID FROM NEW SHARE', channel_id);

  const HeroSectionCard = ({ share_type }) => {
    switch (share_type) {
      case 'comp':
        return (
          <MedwikiHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      case 'session':
        return (
          <SessionHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      case 'training':
        return (
          <TrainingHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      case 'survey':
        return (
          <SurveyHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      case 'archived_video':
        return (
          <ClVideoHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      case 'channel':
        return (
          <ChannelHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      case 'epub':
        console.log('EBOOK FOUND');
        return (
          <EbookHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      case 'doctube':
        return <DoctubeHeroCard gtmTagVariable={`share_${share_type}`} />;
      case 'doctube_fst':
        return <DoctubeHeroCard gtmTagVariable={`share_${share_type}`} />;
      case 'differential_diagnosis':
        return <DiagnosisHeroCard id={page_id} />;
      case 'poll':
        return (
          <PollHeroCard
            gtmTagVariable={`share_${share_type}`}
            data={heroCardData}
            channel_name={channel_name}
            channel_logo={channel_logo}
          />
        );
      default:
        break;
    }
  };

  return (
    <div className="shareLoginV2Frm d-flex align-items-center w-100 position-sticky top-0 w-100 bg-white shadow z-2 min-vh-100">
      <div className="w-100 float-start shareLoginV2_In text-black text-start position-relative z-1 py-3 px-3 py-lg-20 px-lg-4 px-xl-5 py-xl-5">
        {channel_name && channel_logo && (
          <ClirnetIntro channel_name={channel_name} channel_logo={channel_logo} />
        )}
        <div className="w-100 float-start d-block d-lg-none shareLoginV2MainCardArea mb-20">
          {/* session card */}
          <HeroSectionCard share_type={share_type} />
        </div>
        <FormArea
          channel_id={channel_id}
          consent_text={consent_text}
          share_type={share_type == 'doctube_fst' ? 'doctube' : share_type}
          gtmTagVariable={`share_${share_type}`}
          page_id={page_id}
        />
      </div>
    </div>
  );
};

export default memo(RightLoginBar);
